<section class="faq-section" *ngIf="items.length">
  <h2 class="faq-title">{{ title }}</h2>

  <div class="accordion">
    <div class="accordion-item" *ngFor="let item of items; let i = index">
      <h3 class="accordion-header">
        <span class="question">{{ item.question }}</span>
      </h3>
      <div class="accordion-content">
        <p [innerHTML]="item.answer"></p>
      </div>
    </div>
  </div>
</section>
